import { useEffect } from 'react';
import { ensureContrast, readableTextOn, type BusinessBrandingDTO } from '@print-saas/shared';

/** The kiosk screen's dark background (--color-ink). */
const INK = '#0a1020';

/** Logo URLs are relative to the API. */
export const brandAsset = (apiUrl: string, path: string | null) => (path ? `${apiUrl.replace(/\/+$/, '')}${path}` : null);

/**
 * Themes the kiosk screen with the business's colour (made light enough to read on the dark screen) and names the
 * browser tab after the business. Without a colour the screen keeps its own amber accent.
 */
export function useBrandTheme(branding: BusinessBrandingDTO | null | undefined) {
  const color = branding?.color ?? null;
  const name = branding?.name ?? null;
  useEffect(() => {
    const root = document.documentElement.style;
    if (!color) {
      root.removeProperty('--color-accent');
      root.removeProperty('--color-accent-ink');
      return;
    }
    const accent = ensureContrast(color, INK, 4.5);
    root.setProperty('--color-accent', accent);
    root.setProperty('--color-accent-ink', readableTextOn(accent));
  }, [color]);
  useEffect(() => {
    document.title = name ? `${name} · Print` : 'ParthPrint';
  }, [name]);
}
